import { useState } from "react";
import ExteriorViewer from "./ExteriorViewer";
import VideoViewer from "./VideoViewer";
import { exteriorScenes } from "../data/scenes";
import {
  FileText,
  GalleryThumbnailsIcon,
  HomeIcon,
  MapIcon,
  VideoIcon,
} from "lucide-react";
import BrochureViewer from "./BrochureViewer";
import PhotoAlbumViewer from "./PhotoAlbum";

export default function Viewer360() {
  const [mode, setMode] = useState("exterior");

  const [exteriorSceneKey, setExteriorSceneKey] =
    useState("site_view");

  // 🎯 switch mode
  const switchMode = (e, newMode) => {
    e?.preventDefault();

    if (newMode === "map") {
      window.open(
        "https://maps.app.goo.gl/ny8EnFhYenavCxQy6",
        "_blank",
        "noopener,noreferrer"
      );

      return;
    }

    setMode(newMode);

    const targetScenes = exteriorScenes;

    const firstScene = Object.keys(targetScenes)[0];

    if (firstScene) {
      setExteriorSceneKey(firstScene);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* 🎥 VIEWERS */}

      {mode === "exterior" && (
        <ExteriorViewer
          key={`exterior-${exteriorSceneKey}`}
          sceneKey={exteriorSceneKey}
          setSceneKey={setExteriorSceneKey}
          scenes={exteriorScenes}
        />
      )}

      {mode === "brochure" && <BrochureViewer />}

      {mode === "video" && <VideoViewer />}

      {mode === "album" && <PhotoAlbumViewer />}

      {/* 🏷️ LOGO */}
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          zIndex: 30,
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          style={{ height: 70, cursor: "pointer" }}
          onClick={(e) => switchMode(e, "exterior")}
        />
      </div>

      <div
        onClick={(e) => switchMode(e, "exterior")}
        style={{
          position: "absolute",
          top: 10,
          right: 20,
          zIndex: 1000,
          width: 55,
          height: 55,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
          backdropFilter: "blur(6px)",
        }}
      >
        <HomeIcon size={24} />
      </div>

      {/* 📘 BROCHURE BUTTON */}
      <div
        onClick={(e) => switchMode(e, "brochure")}
        style={{
          position: "absolute",
          top: 70,
          right: 20,
          zIndex: 1000,
          width: 55,
          height: 55,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
          backdropFilter: "blur(6px)",
        }}
      >
        <FileText size={24} />
      </div>
      
      <div
        onClick={(e) => switchMode(e, "map")}
        style={{
          position: "absolute",
          top: 130,
          right: 20,
          zIndex: 1000,
          width: 55,
          height: 55,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
          backdropFilter: "blur(6px)",
        }}
      >
        <MapIcon size={24} />
      </div>
      <div
        onClick={(e) => switchMode(e, "video")}
        style={{
          position: "absolute",
          top: 190,
          right: 20,
          zIndex: 1000,
          width: 55,
          height: 55,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
          backdropFilter: "blur(6px)",
        }}
      >
        <VideoIcon size={24} />
      </div>
      <div
        onClick={(e) => switchMode(e, "album")}
        style={{
          position: "absolute",
          top: 250,
          right: 20,
          zIndex: 1000,
          width: 55,
          height: 55,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
          backdropFilter: "blur(6px)",
        }}
      >
        <GalleryThumbnailsIcon size={24} />
      </div>
    </div>
  );
}